// extracted by mini-css-extract-plugin
module.exports = {"paper":"styles_paper__3_Gcl","dummyRightMenu":"styles_dummyRightMenu__2P6fi","imgSkeleton":"styles_imgSkeleton__i5YmP"};